import { type BadgeProps, Badge as CommonBadge } from '@monorepo/common';

function Badge({ children, color, size }: BadgeProps) {
  return (
    <CommonBadge color={color} size={size}>
      {children}
    </CommonBadge>
  );
}

export default Badge;
